module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "edit-networking"
    }
  }, [_c('div', {
    staticClass: "networking edit-container"
  }, [_c('h1', [_vm._v("Networking")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.lookingForGame),
      expression: "formData.lookingForGame"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.lookingForGame) ? _vm._i(_vm.formData.lookingForGame, null) > -1 : (_vm.formData.lookingForGame)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formData.lookingForGame,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.lookingForGame = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formData.lookingForGame = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formData.lookingForGame = $$c
        }
      }
    }
  }), _vm._v("I want to join a Game Project")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.lookingForDescription),
      expression: "formData.lookingForDescription"
    }],
    attrs: {
      "placeholder": "What I'm looking for in a team"
    },
    domProps: {
      "value": (_vm.formData.lookingForDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.lookingForDescription = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitChanges($event)
      }
    }
  }, [_vm._v("Save")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1bf9ed85!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Developer/Widgets/EditDeveloperNetworking.vue
// module id = 831
// module chunks = 2